module.exports = __webpack_public_path__ + "static/semantic-image-floated-62488b6a715c0f3fdc980a9c4efded62.png";